import moment from 'moment';
import { Grid, Box } from '@mui/material';
import { Table, TableRow, TableBody } from '@mui/material';
import { OverviewStyles, OverviewTableCell, OverviewCard } from '../Info';

const ClientDetails = props => {
  const { customerData, changeTab } = props;
  const classes = OverviewStyles();

  return (
    <OverviewCard>
      <Grid container spacing={1}>
        <Grid item xs={4}>
          <Box p={1}>
            <button
              className={classes.headingButton}
              onClick={() => changeTab('account')}
            >
              Account
            </button>
            <Table className={classes.noBorderSpaced}>
              <TableBody>
                <TableRow>
                  <OverviewTableCell>
                    <span className={classes.rowHeader}>Account Balance</span>
                    <span className={classes.rowText}>
                      {customerData?.accountBalance
                        ? customerData.accountBalance.toLocaleString('en-US', {
                            style: 'currency',
                            currency: 'USD',
                            minimumFractionDigits: 2
                          })
                        : '--'}
                    </span>
                  </OverviewTableCell>
                </TableRow>
                <TableRow>
                  <OverviewTableCell>
                    <span className={classes.rowHeader}>Gift Card Balance</span>
                    {customerData?.giftCards &&
                    customerData?.giftCards.length > 0 ? (
                      customerData?.giftCards?.map(card => (
                        <span className={classes.rowText} key={card.last4}>
                          {card.balance.toLocaleString('en-US', {
                            style: 'currency',
                            currency: 'USD',
                            minimumFractionDigits: 2
                          })}{' '}
                          (**{card.last4})
                        </span>
                      ))
                    ) : (
                      <span className={classes.rowText}>--</span>
                    )}
                  </OverviewTableCell>
                </TableRow>
                <TableRow>
                  <OverviewTableCell>
                    <span className={classes.rowHeader}>
                      Default Credit Card
                    </span>
                    <span className={classes.rowText}>
                      {customerData?.defaultPaymentMethod
                        ? customerData?.defaultPaymentMethod?.issuer +
                          ' **' +
                          customerData?.defaultPaymentMethod?.last4
                        : '--'}
                    </span>
                  </OverviewTableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Box>
        </Grid>
        <Grid item xs={4}>
          <Box p={1}>
            <button
              className={classes.headingButton}
              onClick={() => changeTab('membership')}
            >
              Memberships
            </button>
            <Table className={classes.noBorderSpaced}>
              <TableBody>
                {customerData?.memberships &&
                customerData.memberships.length > 0 ? (
                  customerData.memberships.map(membership => {
                    const {
                      previousAutopayStatus,
                      lastAutopayFailure,
                      previousAutopayDate
                    } = membership?.autopay || {};

                    const status =
                      previousAutopayStatus === 'failed'
                        ? 'Failed'
                        : 'Previous';
                    const timestamp =
                      status === 'Failed'
                        ? lastAutopayFailure
                        : previousAutopayDate;
                    return (
                      <TableRow>
                        <OverviewTableCell>
                          <p
                            style={{
                              fontWeight: 'bold',
                              color: '#42afe9'
                            }}
                          >
                            {membership?.description}
                          </p>
                          {timestamp ? (
                            <p>
                              {status} AutoPay on{' '}
                              {moment(timestamp).format('MM/DD/YYYY')}
                            </p>
                          ) : (
                            <p>'No AutoPay Set Up'</p>
                          )}
                        </OverviewTableCell>
                      </TableRow>
                    );
                  })
                ) : (
                  <p>--</p>
                )}
              </TableBody>
            </Table>
          </Box>
        </Grid>
        <Grid item xs={4}>
          <Box p={1}>
            <button
              className={classes.headingButton}
              onClick={() => changeTab('appointments')}
            >
              Appointments
            </button>
            <Table className={classes.noBorderSpaced}>
              <TableBody>
                <TableRow>
                  <OverviewTableCell>
                    {customerData?.appointmentInfo?.previous?.length > 0 ? (
                      <>
                        <span className={classes.rowHeader}>
                          Last Service on{' '}
                          {moment(
                            customerData.appointmentInfo.previous[0].start
                          ).format('MM/DD/YYYY')}
                        </span>
                        {customerData?.appointmentInfo?.previous
                          ?.filter(
                            appointment =>
                              moment(appointment.start).format('YYYY-MM-DD') ===
                              moment(
                                customerData.appointmentInfo.previous[0].start
                              ).format('YYYY-MM-DD')
                          )
                          .map((appointment, index) => (
                            <span key={index} className={classes.rowText}>
                              {appointment?.service?.description}
                            </span>
                          ))}
                      </>
                    ) : (
                      <>
                        <span className={classes.rowHeader}>Last Service</span>
                        <span className={classes.rowText}>--</span>
                      </>
                    )}
                  </OverviewTableCell>
                </TableRow>
                <TableRow>
                  <OverviewTableCell>
                    {customerData?.appointmentInfo?.next?.length > 0 ? (
                      <>
                        <span className={classes.rowHeader}>
                          Next Service on{' '}
                          {moment(
                            customerData.appointmentInfo.next[0].start
                          ).format('MM/DD/YYYY')}
                        </span>
                        {customerData?.appointmentInfo?.next
                          ?.filter(
                            appointment =>
                              moment(appointment.start).format('YYYY-MM-DD') ===
                              moment(
                                customerData.appointmentInfo.next[0].start
                              ).format('YYYY-MM-DD')
                          )
                          .map((appointment, index) => (
                            <span key={index} className={classes.rowText}>
                              {appointment?.service?.description}
                            </span>
                          ))}
                      </>
                    ) : (
                      <>
                        <span className={classes.rowHeader}>Next Service</span>
                        <span className={classes.rowText}>--</span>
                      </>
                    )}
                  </OverviewTableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Box>
        </Grid>
      </Grid>
    </OverviewCard>
  );
};

export default ClientDetails;
